import { render } from "./queryVortestId.vue?vue&type=template&id=00b3dba4"
import script from "./queryVortestId.vue?vue&type=script&lang=js"
export * from "./queryVortestId.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__